// src/App.js or a separate component like GoogleAnalytics.js
import { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Load gtag.js
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-YS08S0QVLW';
    script.async = true;
    document.head.appendChild(script);

    // Init gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-YS08S0QVLW');
  }, []);

  return null;
};

export default GoogleAnalytics;
